export const priceFilters = [
    {
        text: 'Under ₦5,000',
        id: 'lt5000',
    },
    {
        text: '5,000 - 10,000',
        id: 'gt5000',
    },
    {
        text: '₦10,000 - ₦20,000',
        id: 'gt10000',
    },
    {
        text: '₦20,000 - ₦50,000',
        id: 'gt20000',
    },
    {
        text: 'Above ₦50,000',
        id: 'gt50000',
    },
]

export const typeFilters = [
    {
        text: 'Course',
        id: 'course',
    },
    {
        text: 'Class',
        id: 'class',
    },
]

export const premiumFilters = [
    {
        text: 'Premium',
        number: 1,
        id: 'true',
    },
    {
        text: 'Free on Subscription',
        number: 20,
        id: 'false',
    },
]
